import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import functions from "../../../utils/Api";
import { CircularProgress } from "@mui/material";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import CustomBarChart from "../../../components/CustomBarChart";
import moment from "moment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import * as XLSX from "xlsx";
import "./UserDetails.css";
import CustomDatePickerDialog from "../../../components/CustomDatePickerDialog/CustomDatePickerDialog";
import { useDispatch, useSelector } from "react-redux";
import { setCustomMonthUser } from "../../../Redux/reportSlice";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import dayjs from "dayjs";

const Details = () => {
  const location = useLocation();
  let id = location.pathname.split("/")[3];
  const dispatcher = useDispatch();

  const { customMonthUser } = useSelector((state) => state.report);

  const [selectedUserData, setSelectedUserData] = useState(null);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);
  const [mealDetails, setMealDetails] = useState(null);
  const [datePickerStatus, setDatePickerStatus] = useState(false);
  const [customDate, setCustomDate] = useState(
    customMonthUser ? customMonthUser : null
  );
  const [disableBtnLoading, setdisableBtnLoading] = useState(false);
  const [mealTypeId, setMealTypeId] = useState("1");
  const [isoading, setIsloading] = useState(true);

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
    {
      label: "Users List",
      path: "/cms/users-list",
    },
  ];

  const mealDetailsJson = useCallback((data) => {
    data && data.sort((a, b) => new Date(a.mealDate) - new Date(b.mealDate));
    const categories = data
      ? data.map((item) => moment(item.mealDate).format("MMM D"))
      : [];
    const guestsData = data
      ? data?.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "guest")
            .map((item) => item.mealCount)
        )
      : [];
    const selfData = data
      ? data?.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "self")
            .map((item) => item.mealCount)
        )
      : [];
    const contractData = data
      ? data.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "ctr-self")
            .map((item) => item.mealCount)
        )
      : [];
    setMealDetails({
      series: [
        { name: "Self", data: selfData },
        { name: "Guests", data: guestsData },
        { name: "Contract", data: contractData },
      ],
      categories,
    });
  }, []);

  const handleDate = useCallback(() => {
    let startDate = customDate.startOf("month").format("YYYY-MM-DD");
    let endDate = customDate.endOf("month").format("YYYY-MM-DD");
    return { startDate, endDate };
  }, [customDate]);

  useEffect(() => {
    if (selectedUserData && customDate) {
      let { startDate, endDate } = handleDate();
      async function getUserMealData() {
        await functions
          .get(
            `/reports?mealTypeId=${mealTypeId}&locationId=${selectedUserData?.officeLocationId}&startDate=${startDate}&endDate=${endDate}&employeeId=${selectedUserData?.empId}`
          )
          .then((res) => {
            mealDetailsJson(res?.data);
            setdisableBtnLoading(false);
            setDatePickerStatus(false);
            setIsloading(false);
          })
          .catch((err) => {
            console.log(err);
            setIsloading(false);
          });
      }
      getUserMealData();
    }
  }, [customDate, handleDate, mealDetailsJson, mealTypeId, selectedUserData]);

  useEffect(() => {
    if (id) {
      async function fetchUserData() {
        try {
          await functions
            .get(`/employee/${id}`)
            .then((res) => {
              if (res) {
                let name = `${res?.data?.firstName} ${res?.data.lastName}`;
                let details = {
                  Name: name,
                  email: res.data.email ?? "_",
                  "Employee Id": res.data.employeeId ?? "_",
                  Location: res?.data?.locationName ?? "_",
                  "Phone Number": res.data.contactNumber ?? "_",
                  avatar: res.data.profileImage ?? "_",
                };
                setSelectedUserData(res?.data);
                setSelectedUserDetails(details);
              }
            })
            .catch((err) => console.log(err));
        } catch (error) {
          console.log(error);
        }
      }
      fetchUserData();
    }
  }, [id]);

  const handleExport = () => {
    const headers = [
      "Name",
      "Email",
      "EmployeeId",
      "Location",
      "Phone Number",
      "OrderedDate",
      "Self",
      "Guests",
      "Total Meal",
    ];
    const rows = mealDetails.categories.map((date, index) => {
      const self = mealDetails.series[0]?.data[index] || 0;
      const guest = mealDetails.series[1]?.data[index] || 0;
      return {
        Name: selectedUserDetails.Name,
        Email: selectedUserDetails.email,
        EmployeeId: selectedUserDetails.EmployeeId,
        Location: selectedUserDetails.Location,
        "Phone Number": selectedUserDetails["Phone Number"],
        OrderedDate: date,
        Self: self,
        Guests: guest,
        "Total Meal": Number(self) + Number(guest),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(
      workbook,
      `${selectedUserDetails?.Name}-Report-${
        mealTypeId === "1" ? "Breakfast" : "Dinner"
      }-${moment(customMonthUser).format("MMMM,YYYY")}.xlsx`
    );
  };

  const handleCustomDateRange = () => {
    setDatePickerStatus(true);
  };

  const handleCustomMonthChange = (month) => {
    dispatcher(setCustomMonthUser(month));
  };

  const handleDateRangePicker = () => {
    setDatePickerStatus(false);
    // dispatcher(setCustomMonthUser(dayjs()));
  };

  const handleSubmitDateRange = (e) => {
    e.preventDefault();
    setdisableBtnLoading(true);
    setCustomDate(customMonthUser);
  };

  const handleMealTypeChange = (e) => {
    setIsloading(true);
    setMealTypeId(e.target.value);
  };

  const handleBarClick = () => {};

  return (
    <div className="userDetials">
      <Box className="userDetails-breadcrumb">
        <CustomBreadcrumbs
          items={breadCrumbData}
          currentLabel={"User Details"}
        />
      </Box>
      {!isoading ? (
        <Box className="userDetails-main">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "10px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Avatar
                sx={{
                  border: "1px solid #DDD",
                  width: "50px",
                  height: "50px",
                  "& img": {
                    objectFit: "contain",
                  },
                }}
                src={`${process.env.REACT_APP_API_IMAGE_URL}${selectedUserDetails?.avatar}`}
              />
              <Box sx={{ display: "flex" }}>
                <Typography>
                  <MailOutlineIcon />
                </Typography>
                <Typography ml={1}>{selectedUserDetails?.email}</Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box marginRight="20px">
                <TextField
                  size="small"
                  sx={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VolunteerActivismOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  select
                  value={mealTypeId}
                  variant="outlined"
                  onChange={handleMealTypeChange}
                >
                  <MenuItem value={1}>Breakfast</MenuItem>
                  <MenuItem value={2}>Dinner</MenuItem>
                  {/* <MenuItem value={3}>Lunch</MenuItem> */}
                </TextField>
              </Box>

              <Button
                variant="contained"
                startIcon={<DateRangeOutlinedIcon />}
                sx={{
                  borderColor: "#004D72",
                  color: "#FFFFFF",
                }}
                onClick={handleCustomDateRange}
              >
                {dayjs(customDate).format("MMMM,YYYY")}
              </Button>
              <Button
                variant="outlined"
                startIcon={<IosShareOutlinedIcon />}
                sx={{
                  borderColor: "#C1C1C2",
                  color: "black",
                  marginLeft: "20px",
                  "&:hover": { borderColor: "#C1C1C2" },
                }}
                onClick={handleExport}
              >
                Export
              </Button>
            </Box>
          </Box>
          <Divider sx={{ marginBottom: "10px" }} />
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Box>
                <Grid container spacing={1}>
                  {selectedUserDetails !== null &&
                    Object.entries(selectedUserDetails).map(
                      ([key, value], i) => {
                        return (
                          <React.Fragment key={i}>
                            <Grid item xs={12}>
                              <Typography
                                mb={4}
                                className={`userDetails-details ${
                                  key === "email" || key === "avatar"
                                    ? "hideEmailTag"
                                    : ""
                                }`}
                                sx={{ mb: "10px" }}
                              >
                                <b>{key}</b> : <span>{value}</span>
                              </Typography>
                            </Grid>
                          </React.Fragment>
                        );
                      }
                    )}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Box>
                <CustomBarChart
                  chartData={{
                    series: [
                      {
                        name: "Self",
                        label: "Self",
                        data: mealDetails?.series[0]?.data,
                        color: "#1E88E5",
                        stack: "total",
                      },
                      {
                        name: "Guests",
                        label: "Guest",
                        data: mealDetails?.series[1]?.data,
                        color: "#A5D6A7",
                        stack: "total",
                      },
                      {
                        name: "Contract",
                        label: "Contract",
                        data: mealDetails?.series[2]?.data,
                        color: "#EEA53E",
                        stack: "total",
                      },
                    ],
                    categories: mealDetails?.categories,
                  }}
                  barWidth={40}
                  onBarClick={handleBarClick}
                  categoryGapRatio={0.4}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {datePickerStatus && (
        <CustomDatePickerDialog
          value={customMonthUser ? customMonthUser : customDate}
          handleCustomMonthChange={handleCustomMonthChange}
          open={datePickerStatus}
          handleDateRangePicker={handleDateRangePicker}
          handleSubmit={handleSubmitDateRange}
          disableBtnLoading={disableBtnLoading}
        />
      )}
    </div>
  );
};

export default Details;
